import { Wordmark } from "@/app/logo"
import { SocialFooter } from "@/landing/landing"
import { DemoLink } from "@/components/demo_link"
import { classes } from "@/utils"
import { useLocation } from "wouter-preact"

interface BlogLayoutProps {
  children: preact.ComponentChildren
  className?: string
}

const shell = "mx-auto w-full max-w-6xl px-4 lg:px-8"

export function BlogLayout(props: BlogLayoutProps) {
  const { children, className } = props
  const [location] = useLocation()
  const blog_active = location === "/blog" || location.startsWith("/blog/")

  return (
    <div class={classes("mw-blog font-content flex min-h-full w-full flex-col", className ?? "")}>
      <header class="sticky top-0 z-20 border-b border-sky-200/80 bg-white/90 shadow-sm backdrop-blur-md">
        <div class={`${shell} flex flex-wrap items-center justify-between gap-4 py-4`}>
          <a href="/" class="flex items-center gap-3 transition-opacity hover:opacity-90">
            <Wordmark />
          </a>
          <nav class="flex flex-wrap items-center justify-end gap-2 sm:gap-3" aria-label="Marketing">
            <a
              href="/blog"
              class={classes(
                "rounded-full px-3 py-2 text-xs font-bold uppercase tracking-wide transition-colors sm:text-sm",
                blog_active ? "bg-indigo-100 text-indigo-800" : "text-indigo-700 hover:text-indigo-600",
              )}>
              Blog
            </a>
            <a
              href="/login"
              class="rounded-full border border-indigo px-4 py-2 text-xs font-bold uppercase tracking-wide text-indigo-950 transition-colors hover:bg-indigo-50 sm:text-sm">
              Login
            </a>
            <DemoLink
              target="_blank"
              class="rounded-full border border-indigo bg-indigo px-4 py-2 text-xs font-bold uppercase tracking-wide text-white transition-opacity hover:opacity-95 sm:text-sm" />
          </nav>
        </div>
      </header>

      <div class="flex flex-1 flex-col bg-linear-to-b from-sky-50 via-sky-100 to-sky-100">
        <main class="flex-1 py-8 md:py-12">
          <div class={shell}>{children}</div>
        </main>

        <SocialFooter />

        <div class="bg-orange-100 py-8 text-center text-sm text-gray-600">
          <div class="mx-auto max-w-7xl px-4">
            <p>© {new Date().getFullYear()} MarginWiz. All rights reserved.</p>
            <p class="mt-2">
              <a href="/privacy.html" class="text-indigo-600 hover:underline">
                Privacy Policy
              </a>
              {" | "}
              <a href="/terms.html" class="text-indigo-600 hover:underline">
                Terms of Service
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
